import {
  myAxios as axios
} from './index'
const serve = "/template";

/**
 * 识别文件流文件
 * @param params 请求参数
 * @returns {*}
 */
export const OCR2WordFile = (param) => {
  return axios({
    url: `${serve}/ocr/OCR2WordFile.ajax`,
    data: param,
    transformRequest: [
      function (data) {
        return data
      },
    ]
  })
}

/**
 * 识别文件流印章
 * @param params 请求参数
 * @returns {*}
 */
export const stampFile = (param) => {
  return axios({
    url: `${serve}/ocr/stampFile.ajax`,
    data: param,
    transformRequest: [
      function (data) {
        return data
      },
    ]
  })
}